import cx from "clsx";
import { GalleryArtwork } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";

import SecondaryOfferEntryViewer from "./components/SecondaryOfferEntryViewer";
import styles from "./index.module.scss";

import StatusIndicatorViewer from "@/modules/kreate-components/components/StatusIndicatorViewer";
import { useCommandResultInfinite$GetSecondaryOffers } from "@/modules/resources/hooks/useCommandResultInfinite";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  galleryArtwork: GalleryArtwork;
};

export default function TabSell({ className, style, galleryArtwork }: Props) {
  const resource = useCommandResultInfinite$GetSecondaryOffers({
    assetId: galleryArtwork.assetId,
    offset: 0,
    limit: 12,
  });
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Col gap="20px">
        {resource.data
          ?.flatMap((d) => d.offers)
          .map((offer) => (
            <SecondaryOfferEntryViewer
              galleryArtwork={galleryArtwork}
              key={offer.utxo.txId}
              offer={offer}
            />
          ))}
      </Flex.Col>
      <Flex.Row alignItems="center" justifyContent="center" minHeight="96px">
        <StatusIndicatorViewer
          statusIndicator={resource.statusIndicator}
          onClickLoadMore={resource.loadMore}
        />
      </Flex.Row>
    </div>
  );
}
